export const addToCartAjax = (() => {
	// this is used only on single product pages. Ajax add to cart does not work there straight out of the box
	jQuery(function ($) {
		$("form.cart").on("submit", function (e) {
			e.preventDefault();
			$(document.body).trigger("adding_to_cart", []);
			var form = $(this);
			form.block({
				message: null,
				overlayCSS: {
					background: "#fff",
					opacity: 0.6,
				},
			});

			var formData = new FormData(form[0]);

			const isVariableProduct = document.querySelector(".product.product-type-variable") || false;

			const productId = isVariableProduct
				? document.querySelector('input[name="variation_id"]').value
				: form.find("[name=add-to-cart]").val();
			formData.append("product_id", productId);

			// Ajax action.
			$.ajax({
				url: wc_add_to_cart_params.wc_ajax_url.toString().replace("%%endpoint%%", "add_to_cart"),
				data: formData,
				type: "POST",
				processData: false,
				contentType: false,
				complete: function (response) {
					response = response.responseJSON;

					if (!response) {
						return;
					}

					if (response.error && response.product_url) {
						window.location = response.product_url;
						return;
					}

					// Redirect to cart option
					if (wc_add_to_cart_params.cart_redirect_after_add === "yes") {
						window.location = wc_add_to_cart_params.cart_url;
						return;
					}

					var $thisbutton = form.find(".single_add_to_cart_button"); //

					// Remove existing notices
					$(".woocommerce-error, .woocommerce-message, .woocommerce-info").remove();

					// Add new notices
					$(".woocommerce-notices-wrapper").append(response.fragments.notices_html);

					form.unblock();

					// Trigger event so themes can refresh other areas.
					$(document.body).trigger("added_to_cart", response.fragments);
				},
			});
		});
	});
})();
